'use client';

import { type ReactNode, useState, useEffect } from 'react';
import {
  WalletConnectorProvider,
  SolanaProvider,
  TerminalAccessProvider,
  TerminalContextProvider,
  LocationContextProvider,
  LocalizationContextProvider,
} from 'mode-shared/context';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { AccountIcon } from 'mode-shared/components';
import '@rainbow-me/rainbowkit/styles.css';

(BigInt.prototype as any).toJSON = function () {
  return this.toString();
};

export function Providers({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <WalletConnectorProvider>
      <RainbowKitProvider
        appInfo={{
          appName: 'Mode app',
        }}
        locale="en"
        theme={darkTheme({})}
        avatar={({ size }) => <AccountIcon size={size} />}
      >
        <LocalizationContextProvider>
          <LocationContextProvider>
            <TerminalAccessProvider>
              <TerminalContextProvider>
                <SolanaProvider>{mounted && children}</SolanaProvider>
              </TerminalContextProvider>
            </TerminalAccessProvider>
          </LocationContextProvider>
        </LocalizationContextProvider>
      </RainbowKitProvider>
    </WalletConnectorProvider>
  );
}
